import angular from "angular";

angular
	.module('app')
	.component('packetForm', {
		template: require('./packet-form.html'),
        controller: ['$http', '$uibModal', 'moment', 'Notifier', controller],
        bindings: {
            packet: '<',
        }
    });
            
function controller($http, $uibModal, moment, Notifier) {
        
	let $ctrl = this;

	$ctrl.page = 1;

	$ctrl.$onInit = function () {
        $ctrl.getUsers();
    }

	$ctrl.getUsers = () => {
		$ctrl.loading = true;

		$http
			.get(`/admin/packets/${$ctrl.packet.id}/get-users`, {
				params: {
					page: $ctrl.page,
					search: $ctrl.search,
				}
			})
			.then(res => {
				$ctrl.users = res.data.data;
				$ctrl.total = res.data.total;
			})
			.catch(err => {

			})
			.finally(() => {
				$ctrl.loading = false;
			});
	}

	$ctrl.filter = () => {
		$ctrl.page = 1;
		$ctrl.getUsers();
	};

	$ctrl.openImportModal = () => {
		$uibModal
			.open({
				component: 'packetImportStudentsModal',
				size: 'lg',
				resolve: {
					packet() {
						return $ctrl.packet;
					}
				}
			})
			.result
			.finally(() => {
				$ctrl.getUsers();
			});
    }

    $ctrl.openAttachModal = () => {
		$uibModal
			.open({
				component: 'packetStudentsAttachModal',
				size: 'lg',
				resolve: {
					packet() {
						return $ctrl.packet;
					}
				}
			})
			.result
			.finally(() => {
				$ctrl.getUsers();
			});
	};

	$ctrl.openAttachNewStudentModal = function () {
		$uibModal
			.open({
				component: 'userCreateForm',
				size: 'md',
				keyboard: false,
				backdrop: 'static'
			})
			.result
			.then(res => {
				$http
					.post(`/admin/packets/${$ctrl.packet.id}/attach-student`, {user_id: res.id})
					.then(res => {
						$ctrl.getUsers();
					})
					.catch(err => {
						console.log(err);
						Notifier.error(err.data.message);
					});
			});
	};

}